import React from 'react';
import { createPortal } from 'react-dom';
import '../../assets/styles/infrastructure_leasing_modal.scss';

function str(v) {
  if (v == null) return '';
  return String(v).trim();
}

function formatWhen(iso) {
  if (!iso) return '—';
  try {
    return new Date(iso).toLocaleString(undefined, {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch {
    return '—';
  }
}

/**
 * Read-only popup: seller-entered rejection reason and optional comments (buyer + seller enquiry lists).
 */
export default function InfrastructureLeasingRejectionDetailsModal({
  open,
  onClose,
  listingLabel,
  rejectionReason,
  rejectionComments,
  rejectedAt,
}) {
  const suffix = `rej-${str(listingLabel).slice(0, 12) || 'detail'}`;
  if (!open) return null;

  const modalUi = (
    <div className="ile-modal-root">
      <div className="ile-modal-overlay" onClick={onClose} role="presentation">
        <div
          className="ile-modal-panel"
          role="dialog"
          aria-modal="true"
          aria-labelledby={`ile-rej-details-title-${suffix}`}
          tabIndex={-1}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="ile-modal-panel__header">
            <button type="button" className="ile-modal-panel__close" onClick={onClose} aria-label="Close">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden
              >
                <path d="M18 6 6 18" />
                <path d="m6 6 12 12" />
              </svg>
            </button>
            <h2 className="ile-modal-panel__title" id={`ile-rej-details-title-${suffix}`}>
              Rejected details
            </h2>
            {listingLabel ? (
              <p className="ile-modal-panel__subtitle">{str(listingLabel)}</p>
            ) : null}
          </div>

          <div className="ile-modal-panel__body">
            <div className="ile-modal-block">
              <p className="small text-muted mb-2">
                Rejected {formatWhen(rejectedAt)}
              </p>
              <label className="ile-form-label">Reason</label>
              <div className="small text-break mb-3 p-2 bg-light rounded border">
                {str(rejectionReason) ? str(rejectionReason) : <span className="text-muted">No reason recorded.</span>}
              </div>
              <label className="ile-form-label">Additional comments</label>
              <div className="small text-break p-2 bg-light rounded border" style={{ minHeight: 48 }}>
                {str(rejectionComments) ? (
                  str(rejectionComments)
                ) : (
                  <span className="text-muted">None</span>
                )}
              </div>
            </div>
          </div>

          <div className="ile-modal-panel__footer">
            <button type="button" className="btn btn-dark btn-sm" onClick={onClose}>
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );

  if (typeof document !== 'undefined' && document.body) {
    return createPortal(modalUi, document.body);
  }
  return modalUi;
}
